var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnternehmensprofil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.733,
    height: 130.517,
    viewBox: "0 0 171.733 130.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface14809",
    transform: "translate(-3.333 -11.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M35,16.668v109.9H76.216V16.668Zm27.483,89.29H48.733V92.225H62.483Zm0-27.467H48.733V64.743H62.483Zm0-27.483H48.733V37.276H62.483Zm0,0",
    transform: "translate(98.85 15.616)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M120.117,25.4H10.2a6.869,6.869,0,1,1,0-13.739H120.117a6.869,6.869,0,1,1,0,13.739Z",
    transform: "translate(0)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M5,11.668V142.174H46.216V114.708H73.7v27.467h41.216V11.668ZM32.483,128.441H18.733V114.708H32.483Zm0-27.483H18.733V87.225H32.483Zm0-27.467H18.733V59.743H32.483Zm0-27.483H18.733V32.276H32.483ZM73.7,100.958H46.216V87.225H73.7Zm0-27.467H46.216V59.743H73.7Zm0-27.483H46.216V32.276H73.7Zm27.467,82.432H87.432V114.708h13.733Zm0-27.483H87.432V87.225h13.733Zm0-27.467H87.432V59.743h13.733Zm0-27.483H87.432V32.276h13.733Zm0,0",
    transform: "translate(5.203 0.008)",
    fill: "#d6d6d6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnternehmensprofil);
export default __webpack_public_path__ + "static/media/unternehmensprofil.8d6993344ae1c834c5365452c5929776.svg";
export { ForwardRef as ReactComponent };